import { render, staticRenderFns } from "./BrClaimModal.vue?vue&type=template&id=564ecab5&scoped=true"
import script from "./BrClaimModal.vue?vue&type=script&lang=js"
export * from "./BrClaimModal.vue?vue&type=script&lang=js"
import style0 from "./BrClaimModal.vue?vue&type=style&index=0&id=564ecab5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564ecab5",
  null
  
)

export default component.exports